// extracted by mini-css-extract-plugin
module.exports = {"container":"SimpleBox_container_3sbK-"};